import React, {useEffect} from 'react';
import {ThemedDialog, ThemedDrawer} from "../../../index";
import {isBoolTrue} from "../../../../common/fusion-ui/utils/ReactUtils";

const RootInternalDialog = React.memo(({
                                           title = '',
                                           open,
                                           onHide,
                                           children,
                                           asDrawer = false,
                                           closeOnOutsideClick = true,
                                           closeOnEscape = true,
                                           md = 8,
                                           ...rest
                                       }) => {
    const TAG = "RootInternalDialog";

    useEffect(() => {

    }, []);

    return (<>
            {isBoolTrue(asDrawer) ? createDrawer() : createDialog()}
        </>
    )

    function createDialog() {
        return <ThemedDialog
            widthClass={`col-sm-10 col-md-${md}`}
            className={"rounded-5 p-0 m-0 "}
            titleClassName={'fs-lg mb-2x'}
            contentClassName={'pb-3 mb-3x mt-2 px-4'}
            maxHeight={'80vh'}
            open={open}
            title={title}
            showClose={true}
            showFooter={false}
            closeOnEscape={closeOnEscape}
            closeOnOutsideClick={closeOnOutsideClick}
            onHide={onHide}
            {...rest}>
            {children}
        </ThemedDialog>
    }

    function createDrawer() {
        return <ThemedDrawer
            title={title}
            closeOnEscape={closeOnEscape}
            closeOnClickAway={true}
            open={isBoolTrue(open)}
            onClose={onHide}
            {...rest}>
            {children}
        </ThemedDrawer>
    }
});
export default RootInternalDialog;
